import dynamic from 'next/dynamic';
import { useContext, useState } from 'react';

import { Text } from '@/domains/core/tamagoshi/Text/Text';
import { Gtm } from '@/domains/core/tracking/utils/Gtm';
import { CouponContext } from '@/domains/loyalty/components/Coupon/CouponContext';
import {
  genericCouponFooter,
  linkToConditions,
} from '@/domains/loyalty/components/Coupon/translations';

import styles from './CouponDescription.module.scss';

const DynamicCouponModal = dynamic(() =>
  import('../CouponModal/CouponModal').then((mod) => mod.CouponModal),
);

const formattedText = linkToConditions.format({
  strong: (chunks) => <strong key="strong">{chunks}</strong>,
});

const getCouponFooterTranslation = (context: string) => {
  if (['product page', 'A2C', 'cart page'].includes(context)) {
    return formattedText;
  }
  return genericCouponFooter;
};

const onClick = (setModalOpen: (open: boolean) => void, context: string) => {
  setModalOpen(true);
  if (context === 'my_advantages_space') {
    Gtm.push({
      event: 'interaction_click on a link',
      amp_event_name: 'Click on a link',
      event_trigger: 'My coupons',
      click_element: genericCouponFooter,
      page_type: 'my_advantages_space',
    });
  }
};

export const CouponDescription: React.FC = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const { context } = useContext(CouponContext);

  return (
    <>
      <Text
        tag="div"
        type="tiny"
        className={styles.couponDescription}
        role="button"
        onClick={() => onClick(setModalOpen, context)}
        onKeyPress={() => onClick(setModalOpen, context)}
        tabIndex={0}
      >
        {getCouponFooterTranslation(context)}
      </Text>
      {modalOpen && (
        <DynamicCouponModal handleClose={() => setModalOpen(false)} />
      )}
    </>
  );
};
